module.exports = __webpack_public_path__ + "img/logo_marv2.d5bd344a.png";